"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santa-margherita-di-staffora": {
    "14b4907c": [{
      "hkey": "7a6e4acd",
      "slug": "santa-margherita-di-staffora",
      "name": "Santa Margherita di Staffora",
      "primary": true,
      "skipSearch": false
    }],
    "pian-dell-arma": [{
      "hkey": "7a6e4acd",
      "slug": "santa-margherita-di-staffora",
      "name": "Santa Margherita di Staffora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46ae15b9": [{
      "hkey": "1f14a290",
      "slug": "massinigo-sala-vendemiassi",
      "name": "Massinigo-Sala-Vendemiassi",
      "primary": true,
      "skipSearch": false
    }],
    "sala": [{
      "hkey": "1f14a290",
      "slug": "massinigo-sala-vendemiassi",
      "name": "Massinigo-Sala-Vendemiassi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;